import { Box } from "@mui/material";

type Props = {
  productImage: {
    src: string;
    width?: number | null;
    height?: number | null;
  };
  noMountSwatchImage?: string;
};

const NoMountSwatch = ({ productImage, noMountSwatchImage }: Props) => {
  return (
    <Box overflow="hidden" position="relative" width="100%" height="100%" borderRadius="7px">
      <img
        src={noMountSwatchImage}
        alt="mount swatch"
        width="100%"
        height="100%"
        style={{
          position: "relative",
          zIndex: 1,
          objectFit: "cover",
          borderRadius: "8px",
        }}
      />
      <img
        src={productImage.src}
        alt="product"
        width="500%"
        height="auto"
        style={{ position: "absolute", bottom: "33%", right: "20%" }}
      />
    </Box>
  );
};

export default NoMountSwatch;
